const scrollMap = new Map<string, number>();

export const saveScroll = (key: string) => {
  if (typeof window === "undefined") return;

  scrollMap.set(key, window.scrollY);
};

export const restoreScroll = (key: string) => {
  if (typeof window === "undefined") return;

  const y = scrollMap.get(key) ?? 0;

  const html = document.documentElement;
  const prev = html.style.scrollBehavior;

  requestAnimationFrame(() => {
    html.style.scrollBehavior = "auto"; // disable smooth temporarily
    window.scrollTo(0, y);
    html.style.scrollBehavior = prev; // restore
  });
};
